import { TApplicationCategory } from './categories.types';

export const mockedCategoriesData: TApplicationCategory[] = [
  {
    id: '1',
    name: 'category 1',
  },
  {
    id: '2',
    name: 'category 1',
  },
];
